import { MetalPlanPageSection } from '@/page/domain/MetalPlanPageSection';
import { useUrlHelper } from '@/page/infrastructure/composition/useUrlHelper';

const { getIaFQuoteUrl } = useUrlHelper();

export const minimumCoveragePageData: Partial<MetalPlanPageSection> = {
  initialBanner: {
    visible: true,
    title: 'Covered California',
    subtitle: 'Least Expensive Plans',
    subtitleColor: 'text-yellow',
  },
  highlightSection: {
    visible: true,
    content: '<p>Many people are familiar with the Bronze, Silver, Gold and Platinum plans, but the lesser known "Minimum Coverage Plan" has some hidden assets for those under age 30 and have certain situations. The Minimum Coverage plan usually has the least expensive premium with the highest deductible and is mostly a catastrophic plan that protects you from "worst-case scenarios". What many people don´t know is that it offers some free services that can make this plan quite attractive to those on a tighter budget and who normally don´t use very many medical services.</p>',
  },
  textSection: {
    visible: true,
    title: 'Highlights of the Minimum Coverage Plan',
    contentMode: 'centered',
    subContent: [
      '<p>The Minimum Coverage (like all plans) includes free preventative care such as annual physicals (including some mammograms and colonoscopies), well-baby checkups, and immunizations.</p>',
      '<p>The first 3 office visits per year are free (for Primary Care Physician, Urgent Care or Mental Health Therapy visits).</p>',
      '<p>It gives catastrophic protection from very high medical bills. All in-network covered services will be free after you reach the out-of-pocket maximum.</p>',
    ],
  },
  metalPlansSection: {
    visible: false,
    title: 'Bronze 60 vs Minimum Coverage',
    redirectUrl: '/covered-california/plans'
  },
  metalTierHighlight: {
    visible: false,
    title: 'Is the Minimum Coverage Plan Right for Me?',
    subtitle: 'This plan may be right for you if:',
    contentMode: 'twoColumns',
    subContent: [
      '<p>You want a low monthly premium.</p>',
      '<p>You are comfortable with a high deductible, and you mainly want a catastrophic plan.</p>',
      '<p>Your goal is to comply with the Individual Mandate to have health insurance verses having the richest benefits.</p>',
      '<p>You are in good health and typically use very few medical services in a year.</p>',
      '<p>You are not regularly taking costly prescription drugs.</p>',
      '<p>Your income does not qualify you for a subsidy.</p>',
      '<p>You are needing a child only plan or are a young adult under 30 years old.</p>',
    ],
  },
  googleReviewsSection: {
    visible: true,
    title: 'Customer Reviews',
    imageUrl: '/assets/img/bg/guys_working.webp'
  },
  certifiedBanner: {
    visible: true,
  },
  twoColumnSection: {
    visible: true,
    contentDirection: 'right',
    title: 'A Little More to Think About',
    content: '<p>Some people express concern about having the money to pay the high deductible for a Minimum Coverage Plan should something major happen during the year. Not to worry, many of the carriers have payment plans, but you need to ask about it as they may not bring it up unless you do.</p>',
    imageUrl: '/assets/img/bg/bronze_60_a.png',
    redirectText: 'Get a Free Plan Quote',
    redirectUrl: getIaFQuoteUrl()
  },
  finalBanner: {
    visible: true,
    title: 'A LITTLE MORE TO THINK ABOUT',
    imageUrl: '/assets/img/bg/woman_and_doctor_fadedx.png',
    redirectUrl: '/covered-california/plans/hmo-or-ppo'
  }
};
